export class Constants {
  static readonly DATE_FMT = "dd-MMM-yyyy";
  static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm a`;
  static readonly DATE_TIME_ISO_FMT = `YYYY-MM-DDTHH:mm`;
  static readonly MOMENT_DATE_FMT = `DD-MMM-YYYY`;
  static readonly MOMENT_TIME_FMT = `h:mm A`;
  static readonly MOMENT_DATE_TIME_FMT = `DD-MMM-YYYY hh:mm A`;
  static readonly MOMENT_DATE_DAY_FMT = `dddd, MMMM DD, YYYY`;
  static readonly MOMENT_YEAR_FMT = `MMMM YYYY`;
  static readonly MOMENT_DD_FMT = `MMMM DD`;
  static readonly CST_TIMEZONE = "America/Chicago";
  static readonly FROMEMIALDISPLAYNAME = 'MedPoint Team';
  static readonly DROP_DOWN_NONE_OPTION = "None";
  static readonly DROP_DOWN_ALL_OPTION = "All";
  static readonly UTC_TIMEZONE_NAME = "UTC";
  static readonly CST_TIMEZONE_NAME = "Central Standard Time";
  static readonly REGEX_PATTERN_ACTIVITY = "^[A-Za-z0-9 ,*.\-]*$";
  static readonly REGEX_PATTERN_EMAIL = /^(([^<>()\[\]\\.,;:\s@""]+(\.[^<>()\[\]\\.,;:\s@""]+)*)|("".+""))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static readonly REGEX_PATTERN_EMAIL_SPECIAL_CHAR = /^[a-zA-Z0-9._+\-']+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  static readonly REGEX_PATTERN_PHONE = "^[-.+() 0-9]+[0-9]+$";
  static readonly REGEX_PATTERN_SITE_PATH = "^[A-Za-z0-9_-]+$";
  static readonly REGEX_PATTERN_SITE_URL = "[^\\s]*[^/\\\\\\s]$";
  static readonly REGEX_PATTERN_NUMBER_FROM_0_TO_90 = "([1-9]|[1-8][0-9]|90)";
  static readonly PASTE_CLEANUP_SETTINGS = {
    convertMsLists: true,
    removeHtmlComments: true,
    stripTags: ['span', 'h1', 'u'],
    removeMsClasses: true,
    removeMsStyles: true,
    removeInvalidHTML: true
  };
  static readonly EXPORT_DAILY_REQUEST_ERROR_MESSAGE = "You have reached the daily limit for batch downloads. Only one batch download request is allowed per user per day.";
  static readonly EXPORT_SUCCESS_MESSAGE = "File downloaded";
  static readonly EXPORT_NODATA_WARNING_MESSAGE = "No data to export";
  static readonly EXPORT_FAILURE_MESSAGE = "An error has occurred. Failed to generate export file";
  static readonly EXPORT_FILTER_REQUIRED_MESSAGE = "please select at least one filter";
  static readonly CONTENT_DISPOSITION_HEADER = "content-disposition";
  static readonly NOFEATURE_ACCESS_MESSAGE = "This feature is not enabled for the project, or you do not have access to the feature.";
  static readonly IDENTITY_CLAIM_EMAIL = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";
  static readonly IDENTITY_CLAIM_FIRSTNAME = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname";
  static readonly IDENTITY_CLAIM_FULLNAME = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";
  static readonly IDENTITY_CLAIM_NAMEIDENTIFIER = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
  static readonly IDENTITY_CLAIM_LASTNAME = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname";

  static readonly RESOURCE_UPLOAD_SUCCESS_MESSAGE = 'The uploaded resource is being uploaded to the CDN and will be available in approximately 15 minutes.';
  static readonly RESOURCE_UPLOAD_FAILURE_MESSAGE = 'An unexpected error occurred while uploading the resource.';
  static readonly SITE_SUPPORT_EMAIL_DEFAULT = "support@medpt.com";
  static readonly IDENTITY_CLAIM_PASSWORDCHANGEDDATE ="PasswordChangedDate";
  static readonly KENDO_FILTER_OPERATOR = "eq";
  static readonly KENDO_FILTER_LOGIC = "and";
  static readonly KENDO_DATERANGE_FORMAT = "MMMM DD";
  static readonly HELPDESK_MON_THU_START_TIME = "7:30 AM";
  static readonly HELPDESK_FRI_START_TIME = "8:00 AM";
  static readonly HELPDESK_MON_THU_END_TIME = "6:00 PM";
  static readonly HELPDESK_FRI_END_TIME = "5:00 PM";
  static readonly HELPDESK_OPEN_DURATION = 8.5;
  static readonly HELPDESK_CLOSE_DURATION = 8.5;
  static readonly EDIT_HELPDESK_FEATURE_ID = 145;
  static readonly KENDO_PROJECT_TYPE_FILTER_ID = "ProjectTypeId";
  static readonly EVENT_CALENDAR_DATE_FORMAT = "MM/DD/YYYY";
  static readonly TOTAL_NAME = "Total";
  static readonly PREV_SYMBOL = "<";
  static readonly NEXT_SYMBOL = ">";
  static readonly INVALID_EMAIL = "Please enter valid e-mail address";
  static readonly MISSING_REQUIRED_FIELDS = "Please fill all required fileds";
  static readonly ERROR = "Error occured. Please try again";
  static readonly TIMEZONE_UPDATE_SUCCESS = "TimeZone successfully updated";
  static readonly TIMEZONE_UPDATE_ERROR = "Failed to update TimeZone";
  static readonly IMAGEFILETYPEMSG = "['jpeg', 'jpg', 'png', 'tif', 'tiff', 'bmp', 'gif']";
  static readonly VIDEOFILETYPEMSG = "['mp4', 'm4v', 'ogv', 'webm', 'mov', 'wav', 'wave', 'mp3', 'ogg', 'oga', 'ogx', 'ogm', 'spx', 'opus']";
  static readonly ImageFileExtension = ".jpeg, .jpg, .png, .tif, .tiff, .bmp, .gif";
  static readonly VideoFileExtension = ".mp4, .m4v, .ogv, .webm, .mov, .wav, .wave, .mp3, .ogg, .oga, .ogx, .ogm, .spx, .opus";
  static readonly CheckFileNameCharacters = '';
  static readonly azureUploadBlockSize = '';

  static readonly LOCALSTORE_USEROBJECT = 'hashkey_token';
  static readonly LOCALSTORE_CLOSEDNOTIFICATIONIDS = 'dontShowNotificationIds';
  static readonly LOCALSTORE_SIGNINID = 'signingId';
  static readonly LOCALSTORE_RETURNURL = 'returnUrl';
  static readonly ROLETYPENAME_PROJECTTEAM = 'Project Team';
  static readonly ROLETYPENAME_SITEUSER = 'Site Users';
  static readonly SITE_VERIFY_NOTIFICATION_INTERVAL = 7;
  static readonly OUTSIDE_CANADA_US_STATE_ID = 0;
  static readonly US_COUNTRY_ID = 1;
  static readonly CANADA_COUNTRY_ID = 2;
  static readonly REGEX_MEDPT_ID_FORMAT: RegExp = /^(.{4})(.*)$/;
  static readonly REGEX_WHITE_SPACES: RegExp = /\s/g;
  static readonly SUPPORTED_FILE_FORMAT_MESSAGE =
    "Supported file formats are txt, bmp, tiff, jpeg, gif, dicom, png, pdf, rtf, ppt, pptx, xls, xlsx, doc, docx, csv, msg, eml";
  static readonly LOCALSTORE_DONTSHOWSITEVERIFYNOTIFICATION = 'dontShowSiteVerifyNotification';
  static readonly READYTOASSIGN = 'Ready to Assign';
  static readonly READYTOARCHIVE = 'Ready to Archive';
  static readonly WHITESPACEONLYVALIDATION = /^(\s+\S+\s*)*(?!\s).*$/;
  static readonly STARTUPEMAILTASKREFERENCETYPEID = 7;
  static readonly STARTUPINVITEEMAILTEMPLATE = 'Study Startup Invite';
  static readonly STARTUPSITESELECTIONMAILTEMPLATE = 'Startup Site Selection';
  static readonly STARTUPTARGETMETRICNAME = 'Target Total';
  static readonly STARTUPTARGETMETRICCOLOR = '#00679a';
  static readonly STARTUPFORECASTMETRICNAME = 'Forecast';
  static readonly STARTUPFORECASTMETRICCOLOR = '#00a65a';
    static readonly STARTUPMETRICBORDERCOLOR = '#848484';
    static readonly SITETYPE_STUDYSITE_ID = 3;
    static readonly SITETYPE_MEDPOINTSITETYPE_NAME = 'MedPoint';
    static readonly RASPberryAI_FEATURE_NAME = 'RASPberryAI';
    static readonly RASPberryAI_FEATURE_ID = 539;    
    static readonly RASPberryAI_HOME_ROUTE = 'RASPberryAIHome';    
    static readonly RASPberryAI_CHATBOT_FEATURE_NAME = 'AIChatbot';
    static readonly RASPberryAI_AIAssistant_FEATURE_NAME = 'AIAssistant';
    static readonly ASSIGN_REVIEWER_FEATURE_NAME = 'AssignReviewerFeature';
  static readonly INSTANTFORUM_TITLE_TRUNCATE_LIMIT = 70;
}
